// Rarity display order for listing grids, rarest first. This sort used to live in the
// API's GET /listings; the API now returns listings unsorted and every page sorts here.
const RARITY_ORDER = [
    'Special Illustration Rare',
    'Illustration Rare',
    'Shiny Ultra Rare',
    'Shiny Rare',
    'Ultra Rare',
    'Hyper Rare',
    'Double Rare',
    'Rare Holo VMAX',
    'Rare Holo VSTAR',
    'Rare Holo V',
    'Rare Secret',
    'Rare Rainbow',
    'Rare Shiny GX',
    'Rare Holo GX',
    'Rare Ultra',
    'Rare Holo EX',
    'Rare Holo LV.X',
    'Rare Prime',
    'Rare BREAK',
    'Rare Prism Star',
    'Rare Shiny',
    'Rare Shining',
    'Amazing Rare',
    'Rare ACE',
    'ACE SPEC Rare',
    'LEGEND',
    'Classic Collection',
    'Trainer Gallery Rare Holo',
    'Rare',
    'Rare Holo',
    'Promo',
    'Uncommon',
    'Common',
    'NULL',
];

const rarityRank = (listing) => {
    const rarityIndex = RARITY_ORDER.indexOf(listing.cert?.card?.rarity);
    return rarityIndex === -1 ? RARITY_ORDER.length : rarityIndex;
};

export const sortListingsByRarity = (listings) => [...listings].sort((a, b) =>
    rarityRank(a) - rarityRank(b)
    || (b.cert?.card?.name || '').localeCompare(a.cert?.card?.name || '')
    || (b.price || 0) - (a.price || 0)
);
